import styled from '@emotion/styled';
import { rgba } from 'polished';

export const StyledHr = styled.hr`
  margin: 0;
  padding: 0;
  height: 1px;
  background-color: ${rgba('#788ea4', 0.4)};
  border: none;

  ${({ theme }) => theme?.stylesExtension?.styledHr?.hr}
`;
